import { useState } from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { validationSchemaClientSubmit } from './validationSchemaClientSubmit.ts';
import { useNavigate } from 'react-router';
import { CreateFormContext } from './CreateFormClientContext.tsx';
import { TFormValues, TSubmitData } from '../types.ts';
import { initialFormValues } from '../constants.ts';
import SuccessModal from '~/components/modals/SuccessModal/SuccessModal.tsx';
import ModalAlert from '~/components/modals/ModalAlert/ModalAlert';
import { useAppDispatch } from '~/store/appDispatch.ts';
import { createApplicationPersonalDataClient } from '~/store/processing-personal/thunks/personalDataApplicationsThunks.ts';
import { infoMessages } from '~/constants/infoMessages.js';
import { errorMessages } from '~/constants/errorMessages.js';
import { styles } from '~/modules/styles.ts';
import { Box } from '@mui/material';

const PersonalDataCreateApplicationByClient = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [isOpenModalAlert, setIsOpenModalAlert] = useState<boolean>(false);
  const [isOpenModalSuccess, setIsOpenModalSuccess] = useState<boolean>(false);
  const [modalAlertText, setModalAlertText] = useState<string>('');
  const [modalSuccessText, setModalSuccessText] = useState<string>('');

  const form = useForm<TFormValues>({
    defaultValues: initialFormValues,
    resolver: yupResolver(validationSchemaClientSubmit),
    mode: 'onTouched',
    reValidateMode: 'onChange',
  });

  const handleBack = (): void => {
    navigate('/');
  };
  const closeModalAlert = (): void => setIsOpenModalAlert(false);

  const onSubmit: SubmitHandler<TFormValues> = async (values) => {
    const data: TSubmitData = {
      financialServices: { selected: false },
      cardAccess: { selected: values.cardAccess },
      businessRelationship: { selected: false },
      creditBureauData: { selected: false },
      email: values.email,
      phone: values.phone,
    };

    try {
      await dispatch(createApplicationPersonalDataClient(data));
      setIsOpenModalSuccess(true);
      setModalSuccessText(infoMessages.APPLICATION_CREATED);
    } catch {
      setIsOpenModalAlert(true);
      setModalAlertText(errorMessages.SERVICE_UNAVAILABLE);
    }
  };

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Box sx={styles.pageContainer}>
          <Box sx={styles.formWrapper}>
            <CreateFormContext />
          </Box>
        </Box>

        {isOpenModalSuccess && (
          <SuccessModal
            isOpen={isOpenModalSuccess}
            text={modalSuccessText}
            onClose={handleBack}
            showButton
            buttonValue={'Готово'}
            dataTestId="modalSuccess"
          />
        )}
        {isOpenModalAlert && (
          <ModalAlert
            isOpen={isOpenModalAlert}
            text={modalAlertText}
            onClose={closeModalAlert}
            dataTestId="modalAlert"
          />
        )}
      </form>
    </FormProvider>
  );
};

export default PersonalDataCreateApplicationByClient;
